module.exports = __webpack_public_path__ + "img/test.a8cb614b.png";